<style lang="scss">
.zoezi-resource-booking-category {
    .title {
        font-size: 5vw;
    }
    .card-image {
        position: relative;
    }
    .card-title {
        position: absolute;
        left: 0px;
        bottom: 0px;
        width: 100%;
        font-size: 5vw;
        text-align: center;
    }
}
</style>

<template>
    <div v-if="category" class="zoezi-resource-booking-category">
        <div class="title primary--text text-center my-4">{{$translate('Book')}} {{category.name}}</div>
        <v-row no-gutters>
            <v-col cols=12 md=6>
                <v-auto-img :src="image" :ar="3/2">
                    <div class="primary card-title" :style="background" v-if="$vuetify.breakpoint.mobile">
                        <div class="primarytext--text">{{category.name}}</div>
                    </div>
                </v-auto-img>
            </v-col>
            <v-col cols=12 md=6>
                <v-sheet class="primarytext--text pa-8 fill-height" color="#f4f4f4">
                    <div class="title primary--text" v-if="!$vuetify.breakpoint.mobile">{{category.name}}</div>

                    <div v-html="category.description" class="black--text" />
                </v-sheet>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols=12 md=6>
                <h2 class="title primary--text px-3">{{$translate('We offer')}}</h2>
                <v-expansion-panels accordion  v-model="currentOpenServiceDescription">
                    <v-expansion-panel v-for="service in servicesOnFilteredSites" :key="service.id">
                        <v-expansion-panel-header class="px-6 d-flex">
                            <div class="d-flex">
                                <div class="flex-grow-1 align-self-center">{{service.name}}</div>
                                <div><v-icon color="primary" class="mr-1">mdi-clock-outline</v-icon>{{service.duration}} {{$translate('MINUTES_SHORT')}}</div>
                            </div>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content class="px-3 z-dense">
                            <div v-html="service.description" class="my-2" />

                            <v-row>
                                <v-col cols=6 v-if="showPrice">
                                    <v-icon class="mr-1" color="primary">mdi-tag-outline</v-icon>{{service.price | price}}
                                </v-col>
                                <v-col :cols="showPrice ? 6 : 12">
                                    <v-icon class="mr-1" color="primary">mdi-clock-outline</v-icon>{{service.duration}} {{$translate('MINUTES_SHORT')}}
                                </v-col>
                                <v-col cols=6 v-for="staff in service.staffs" :key="staff.id">
                                    <v-avatar size="30" class="mr-1">
                                        <img class="zoezi-staff-image" :src="staff.imagekey ? $api.getImageUrl(staff.imagekey, 100) : $api.getAssetUrl('/assets/img/profile_avatar_man.jpg')" style="width:30px; height:30px" />
                                    </v-avatar>
                                    <a href="" class="primary--text z-no-underline" @click.prevent="doShowStaffInfoDialog(staff)">{{getName(staff)}}</a>
                                </v-col>
                            </v-row>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>

                <h3 v-if="servicesOnFilteredSites.length == 0 && !loadingServices" class="px-3">
                    {{$translate('No services are offered at the moment')}}
                </h3>
            </v-col>
            <v-col cols=12 md=6>
                <component-wrapper
                    :config="{component: 'zoezi-resourcebooking', props: {categoryId, serviceIds, filterSites: filterOnSites, showSiteFilter: !filterOnSites, defaultServices, siteId: siteId}}"
                />
            </v-col>
        </v-row>
        <staff-info-dialog v-model="showStaffInfoDialog" :staff="showStaff" />
    </div>
    <v-card v-else-if="$root.edit" color="zoezi-edit-color" dark height="100">
        <v-card-title>{{$translate('Choose category for resource booking')}}</v-card-title>
    </v-card>
</template>

<script>
import {getName} from '../util.js'
import { intersection } from 'lodash';
import StaffInfoDialog from '../components/StaffInfoDialog.vue'
import ResourceBooking from '../views/ResourceBooking.vue'
export default {
    name: 'zoezi-resource-booking-category',

    zoezi: {
        title: 'Resource booking category',
        icon: 'mdi-book',
        addon: 'ResourceBooking'
    },

    props: {
        categoryId: {
            title: 'Category',
            type: Number,
            fulltype: 'select',
            typeinfo: {
                multiple: false,
                text: 'name',
                value: 'id',
                getItems: () => window.$booking.getResourceBookingCategories(),
                selectFirst: true
            }
        },
        globalSiteSetting: {
            title: 'Filter by globally selected site',
            type: Boolean,
            default: true
        },
        sites: {
            title: 'Filter by site',
            type: Array,
            fulltype: 'select',
            typeinfo: {
                getItems() {
                    return window.$zoeziapi.get('/api/public/settings/get').then(settings => {
                        return settings.sites.sort((a,b) => a.name.localeCompare(b.name));
                    });
                },
                text: 'name',
                value: 'id',
                multiple: true,
                placeholder: 'Show all sites',
                visible: '!globalSiteSetting'
            },
            default: () => []
        }
    },

    components: {
        StaffInfoDialog,
        /* eslint-disable vue/no-unused-components */
        ResourceBooking
    },

    watch: {
        categoryId: {
            immediate: true,
            handler(categoryId) {
                this.loadingServices = true;
                this.$api.get('/api/public/resourcebooking/service/get', {category: categoryId}).then(services => {
                    this.services = services
                    this.loadingServices = false;
                });
            }
        },
        servicesOnFilteredSites() {
            if (this.servicesOnFilteredSites && this.servicesOnFilteredSites.length == 1) {
                this.currentOpenServiceDescription = 0;
            } else {
                if (this.currentOpenService) {
                    let newIndex = this.servicesOnFilteredSites.findIndex(x => x.id == this.currentOpenService.id);
                    if (newIndex != -1) {
                        this.currentOpenServiceDescription = newIndex;
                        return;
                    }
                }
                this.currentOpenServiceDescription = null;
            }
        },
        currentOpenServiceDescription() {
            this.currentOpenService = this.currentOpenServiceDescription != null ? this.services[this.currentOpenServiceDescription] : null;
        }
    },

    data: () => ({
        services: [],
        currentOpenServiceDescription: null,
        currentOpenService: null,
        loadingServices: false,
        showStaffInfoDialog: false,
        showStaff: null
    }),

    computed: {
        category() {
            return this.$store.state?.settings?.resourcebookingcategories?.find(x => x.id == this.categoryId);
        },
        filterOnSites() {
            if (this.globalSiteSetting) {
                return [this.$store.state.selectedSiteId || 1];
            }
            
            if (!this.sites || this.sites.length == 0) {
                return null;
            }

            return this.sites;
        },
        servicesOnFilteredSites() {
            return this.services.filter(service => {
                if (!this.filterOnSites) {
                    return true;
                }

                return intersection(this.filterOnSites, service.sites).length > 0;
            });
        },
        serviceIds() {
            return this.servicesOnFilteredSites.map(service => service.id);
        },
        defaultServices() {
            if (this.currentOpenServiceDescription != null) {
                return [this.servicesOnFilteredSites[this.currentOpenServiceDescription].id];
            }
            return [];
        },
        image() {
            return this.category.imagekey;
        },
        background() {
            return {'background-color': this.$root.colorToHex('primary') + 'b4 !important'};
        },
        siteId() {
            if (this.globalSiteSetting) {
                return this.$store.state.selectedSiteId || 1;
            }

            return null;
        },
        showPrice() {
            return !!this.$store.state.settings?.modules?.Payment;
        }
    },

    methods: {
        getName,
        doShowStaffInfoDialog(staff) {
          this.showStaffInfoDialog = true;
          this.showStaff = staff;
        }
    }
}
</script>